import { useState } from "react";
import "./Home.css"; // Importing external CSS file for styling
import { useNavigate } from "react-router-dom";
import TourNavigator from "./TourNavigator_/TourNavigator";
import { Align, Position } from "./TourNavigator_/types";
import TourHelperTwo from "./TourHelperTwo";

const images = Array(36).fill("https://marketplace.canva.com/EAFqNrAJpQs/1/0/1600w/canva-neutral-pink-modern-circle-shape-linkedin-profile-picture-WAhofEY5L1U.jpg")

const data = [
  {
    selector: '#title',
    data: { title: 'Page Title', description: 'This is page title', image: 'https://example.com/image0.jpg' },
    align: Align.START
  },
  {
    selector: '#sidebar',
    data: { title: 'Posts', description: 'You will find latest post here', image: 'https://example.com/image0.jpg' },
    align: Align.START,
    position: Position.BOTTOM
  },
  {
    selector: '.emoji',
    data: { title: 'Emoji', description: 'Dynamic emoji', image: 'https://example.com/image0.jpg' },
  },
  {
    selector: '#img-0',
    data: { title: 'John Doe', description: 'Photographer extraordinaire', image: 'https://example.com/image0.jpg' },
    align: Align.START
  },
  {
    selector: '#img-1',
    data: { title: 'Alice Smith', description: 'Nature enthusiast and explorer', image: 'https://example.com/image1.jpg' }
  },
  {
    selector: '#img-5',
    data: { title: 'Michael Johnson', description: 'Adventure seeker and storyteller', image: 'https://example.com/image5.jpg' }
  },
  {
    selector: '#img-6',
    data: { title: 'Emily Brown', description: 'Art lover and creative mind', image: 'https://example.com/image6.jpg' },
    position: Position.LEFT
  },
  {
    selector: '#img-18',
    data: { title: 'David Lee', description: 'Travel enthusiast and culture connoisseur', image: 'https://example.com/image18.jpg' }
  }
];

function Home() {
  const [showEmoji, setShowEmoji] = useState(false)
  const [isOpen, setTourOpen] = useState(true)
  const navigate = useNavigate()

  return (
    <div className="container" style={{marginTop: 100}} id="container">
      <header id="header">
        <h1 id="title">Welcome to our Website</h1>
        <nav id="navbar">
          <ul>
            <li><a href="#" id="home-link">Home</a></li>
            <li><a href="#" id="about-link">About</a></li>
            <li><a href="#" id="contact-link">Contact</a></li>
          </ul>
        </nav>
      </header>
      {
        showEmoji && <div className="emoji">😀</div>
      }
      <section id="main-content">
        <article id="article">
          <h2 id="article-title">Latest News</h2>
          <p id="article-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam sagittis mi sit amet nunc volutpat, at euismod libero fermentum.</p>
        </article>
        
        <aside id="sidebar">
          <h2 id="sidebar-title">Popular Posts</h2>
          <ul>
            <li id="post1">Post 1</li>
            <li id="post2">Post 2</li>
            {/* Add more posts here */}
          </ul>
        </aside>
      </section>
      <br />
      <br />
      <section className="gallery">
          {
            images.map((img, id) => {
              return <img key={id} src={img} id={`img-${id}`}/>
            })
          }
      </section>
      
      {/* <MultiRouteTour
          id={'home'}
          isOpen={isOpen}
          number={1}
          onRequestClose={() => setTourOpen(false)}
          steps={data}
          helper={TourHelperTwo}
          nextStepCount={10}
          nextStepRoute="/about"
          onAfterOpen={() => console.log('opend')}
          onBeforeClose={() => console.log('closed')}
          replace={false}
        /> */}
        <TourNavigator
          mutationObserve='#container'
          steps={data}
          helper={TourHelperTwo}
          onMove={({currentStepIndex, previousStepIndex}) => {
            setTimeout(() => {
              setShowEmoji(currentStepIndex === previousStepIndex)
            }, 1000)
          }}
          waitForElementRendered
        />
    </div>
  );
}

export default Home;
